var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "app-wrapper",
      class: {
        dex: _vm.$route.name.indexOf("trade") !== -1,
        wallet: _vm.$route.name.indexOf("trade") === -1
      },
      attrs: { id: "vite-wallet-app" }
    },
    [_c("router-view"), _vm._v(" "), _c("notice-list")],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }